<div class="promotion-history-page">
    <h1 class="title">{{ 'sebbie.expired_promotions' | translate }}</h1>

    @if(pastPromotions.length === 0 && !error && !initLoading)
    {
        <div class="no-past-promotions">
            <p>{{ 'sebbie.no_past_promotions' |  translate }}</p>
        </div>
    }

    @if(pastPromotions.length > 0 && !initLoading)
    {
        <div
            class=""
            [class.d-none]="isServer"
            infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollUpDistance]="50"
            [scrollWindow]="true"
            (scrolled)="loadPromotions()"
        >
            @for(pastPromotion of pastPromotions; track pastPromotion.id)
            {
                <header-content-task
                    [profile]="profile"
                    [promotionAction]="pastPromotion"
                    [availableTaskIds]="pastPromotion.tasksIds"
                    [completedTaskIds]="pastPromotion.completedTaskIds"
                    [spotsReceived]="pastPromotion.spots || 0"
                    [isCurrentPromotion]="false"
                />
            }
        </div>
    }

    @if(initLoading || loading  && !error)
    {
        <div class="loading">
            <mat-progress-spinner
                class="loading-spinner"
                [diameter]="100"
                mode="indeterminate"
                color="primary"
            >
            </mat-progress-spinner>
        </div>
    }

    @if(!initLoading && !loading && error)
    {
        <div class="error">
            <p>{{ 'sebbie.error_past_promotions' |  translate }}</p>
        </div>
    }
</div>
